import { default as Text } from './Text';

export default Text;
